import { render } from "./MobileNumberInput.vue?vue&type=template&id=12418e0d"
import script from "./MobileNumberInput.vue?vue&type=script&lang=js"
export * from "./MobileNumberInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__